export default __webpack_public_path__ + "static/stargazer-hero-cef8c240393c9cac2ed69f82d7e686d5.jpg";